const getFeatureToggle = (featureToggleName: string): boolean =>
  process.env[featureToggleName] === 'true';

export const MOCK_LOGIN = getFeatureToggle('REACT_APP_MOCK_LOGIN');
export const NEW_ADMIN = getFeatureToggle('REACT_APP_NEW_ADMIN');
